import { formatWalletAddress } from "./walletAddress";

export const CONNECTED_WALLET_VALUE = "connected-wallet";
export const DISCONNECT_WALLET_VALUE = "disconnect-wallet";

export function buildWalletHeaderOptions({
  connectors = [],
  canLogout = false,
  isAuthenticated = false,
  session = null,
  walletCanSignTransaction = false
} = {}) {
  const logoutOption = {
    value: DISCONNECT_WALLET_VALUE,
    label: "Log out",
    action: "disconnect"
  };

  if (isAuthenticated && walletCanSignTransaction) {
    return {
      value: CONNECTED_WALLET_VALUE,
      placeholder: "",
      options: [
        {
          value: CONNECTED_WALLET_VALUE,
          label: formatWalletAddress(session?.walletAddress || session?.userId),
          action: "current"
        },
        logoutOption
      ]
    };
  }

  if (isAuthenticated) {
    return {
      value: "",
      placeholder: "Reconnect wallet",
      options: [
        ...connectors.map((connector) => ({
          value: connector.id,
          label: connector.name,
          action: "connect"
        })),
        logoutOption
      ]
    };
  }

  if (canLogout) {
    return {
      value: "",
      placeholder: "Select wallet",
      options: [
        ...connectors.map((connector) => ({
          value: connector.id,
          label: connector.name,
          action: "connect"
        })),
        logoutOption
      ]
    };
  }

  return {
    value: "",
    placeholder: "Select wallet",
    options: connectors.map((connector) => ({
      value: connector.id,
      label: connector.name,
      action: "connect"
    }))
  };
}
